import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * Standard div with opinionated box-sizing.
 */


var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"])));
Box.displayName = 'Box';
/**
 * Flex container
 */

var Flex = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
Flex.displayName = 'Flex';
/**
 * Grid container
 */

var Grid = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n"])));
Grid.displayName = 'Grid';
export { Box, Flex, Grid };